import type { JSX } from 'react';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import { ActionIcon } from '@mantine/core';
import { celestialToggleVariants } from '../../motion';
import { useColorSchemeToggle } from './useColorSchemeToggle';
import classes from './ColorSchemeToggle.module.css';

function ColorSchemeToggle(): JSX.Element {
  const { isDark, toggleColorScheme } = useColorSchemeToggle();
  const prefersReducedMotion = useReducedMotion();

  return (
    <ActionIcon
      onClick={toggleColorScheme}
      variant="subtle"
      size="lg"
      aria-label="Toggle color scheme"
      className={classes.toggle}
    >
      <AnimatePresence mode="wait">
        {isDark ? (
          <motion.div
            key="sun"
            className={classes.sun}
            variants={prefersReducedMotion ? undefined : celestialToggleVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <IconSun size={18} stroke={1.75} />
          </motion.div>
        ) : (
          <motion.div
            key="moon"
            className={classes.moon}
            variants={prefersReducedMotion ? undefined : celestialToggleVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <IconMoon size={18} stroke={1.75} />
          </motion.div>
        )}
      </AnimatePresence>
    </ActionIcon>
  );
}

export default ColorSchemeToggle;
